import { memo, useMemo } from 'react';
import { Chip, Stack, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OfferScopeChip } from 'modules/sales-offer/common/components/OfferScopeChip';
import { IOffer } from 'modules/sales-offer/offer/interfaces';
import { IProductDiscount } from '../../interfaces';
import { getOfferPlaceLabel } from '../../utils/offer-place.utils';

type ProductDiscountScopeCellProps = {
  data?: IProductDiscount;
  /** La tabla no tiene ancho para 8 chips: un contador con tooltip. */
  compact?: boolean;
};

const ProductDiscountScopeCell = ({ data, compact }: ProductDiscountScopeCellProps) => {
  const { t } = useTranslation('productDiscount');

  const labels = useMemo(
    () => (data?.places ?? []).map((place) => getOfferPlaceLabel(place, t('scope.wholeProvince'))),
    [data?.places, t],
  );

  // `!== false` y NO `=== true`: las ofertas anteriores a esta feature no tienen
  // el campo, y son globales. Con `=== true` saldrian todas como regionales.
  if (data?.isGlobal !== false) {
    // Se reusa el chip de las ofertas de orden. Solo se alcanza su rama global,
    // que no toca `distributionCenter`, asi que el cast es seguro.
    return <OfferScopeChip data={data as unknown as IOffer} />;
  }

  if (compact) {
    return (
      <Tooltip title={labels.join(' · ') || t('scope.empty')}>
        <Chip size='small' variant='outlined' label={t('scope.regionsChip', { count: labels.length })} />
      </Tooltip>
    );
  }

  return (
    <Stack direction='row' gap={1} flexWrap='wrap'>
      {labels.map((label) => (
        <Chip key={label} size='small' variant='outlined' label={label} />
      ))}
    </Stack>
  );
};

export default memo(ProductDiscountScopeCell);
